export function isIOS() {
	if (typeof navigator === 'undefined') return false;
	return /(iPad|iPhone|iPod|Macintosh)/.test(navigator.userAgent) && !(window as any).MSStream;
}
